// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/volcanic-ash.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/volcanic-ash/volcanic-ash.js';

mount([g0]);
